module.exports = __webpack_public_path__ + "static/media/icon_phone.e05c84db.svg";